<template>
	<div  :aria-busy="loading ? 'true' : 'false'">
		<div v-if="!loading">
			<section class="content__custom">
				<div class="main-title">
					<h1 class="answers">
						{{ 'intentions' | translate | titleCase }}
					</h1>
					<h2>{{ 'positionings-subtitle' | translate }}</h2>
				</div>

				<div class="tabs">
					<nav class="tabs__navigation">
						<ul>
							<li :class="`${activeSection === 'ativos' ? 'tabs__navigation--active' : ''}`">
								<a href="#ativos" @click.prevent="changeSection('ativos')">
									{{ $t('active', {}, 2 ) }}
								</a>
							</li>
							<li :class="`${activeSection === 'pendentes' ? 'tabs__navigation--active' : ''}`" @click="getPendingKnowledges()">
								<a href="#pendentes" @click.prevent="changeSection('pendentes')">
									{{ $t('pending', {}, 2 ) }}
								</a>
							</li>
						</ul>
					</nav>

					<div class="toolbar">
						<button class="toolbar__item" type="button" @click="synchronizeIntents(activeSection)" :aria-label="$options.filters.translate('sync')">
							<i class="fas fa-sync" aria-hidden="true"></i>
							{{ 'to-synchronize' | translate }}
						</button>
						<div class="toolbar__message" aria-live="assertive" v-show="message">
							{{ message }}
						</div>
					</div>

					<section id="ativos" :class="`tab__entry-content  ${activeSection === 'ativos' ? 'tab__entry-content--active' : ''}`">
						<div :aria-busy-box="loading ? 'true' : 'false'">
							<div v-if="!loading">
								<activatedKnowledges></activatedKnowledges>
							</div>
						</div>
					</section>
					<section id="pendentes" :class="`tab__entry-content  ${activeSection === 'pendentes' ? 'tab__entry-content--active' : ''}`">
						<div :aria-busy-box="pendingLoading ? 'true' : 'false'">
							<div v-if="!pendingLoading">
								<pendingThemes></pendingThemes>
							</div>
						</div>
					</section>
				</div>
			</section>
		</div>
	</div>
</template>
<script>
import activatedKnowledges from './activatedKnowledges.vue';
import pendingThemes from './pendingThemes.vue';

export default {
	name: 'knowledge',
	data() {
		return {
			session: {
				apiKey: sessionStorage.getItem('apiKey'),
				userId: sessionStorage.getItem('userId'),
			},
			loading: false,
			pendingLoading: false,
			activeSection: 'ativos',
			message: '',
		};
	},
	components: {
		activatedKnowledges,
		pendingThemes,
	},
	methods: {
		changeSection(section) {
			if (this.message) {
				this.message = '';
			}

			this.activeSection = section;
		},
		toggleLoading() {
			this.loading = !this.loading;
		},
		togglePendingLoading() {
			this.pendingLoading = !this.pendingLoading;
		},
		getPendingKnowledges() {
			this.togglePendingLoading();
			this.$store.dispatch('getPendingThemes', this.session)
				.then(() => {
					this.togglePendingLoading();
				})
				.catch(() => {
					this.togglePendingLoading();
				});
		},
		synchronizeIntents(tab = 'getActiveKnowledges') {
			const { translate } = this.$options.filters;
			const params = {
				apiKey: this.session.apiKey,
				userId: this.session.userId,
				sync: 1,
			};

			let filter = '';

			switch (tab) {
			case 'active':
			case 'ativos':
				filter = 'getActiveKnowledges';
				break;
			case 'pending':
			case 'pendentes':
				filter = 'getPendingThemes';
				break;

			default:
				filter = 'getActiveKnowledges';
				break;
			}

			this.message = translate('synchronizing');

			this.$store.dispatch(filter, params)
				.then(() => {
					this.message = translate('succesfull-sync');
				})
				.catch(() => {
					this.message = translate('unsuccesfull-sync');
				})
				.finally(() => {
					setTimeout(() => { this.message = ''; }, 5000);
				});
		},
	},
	mounted() {
		this.toggleLoading();
		this.$store.dispatch('getActiveKnowledges', this.session)
			.then(() => {
				this.toggleLoading();
			})
			.catch(() => {
				this.toggleLoading();
			});
	},
};
</script>




// WEBPACK FOOTER //
// _source/javascripts/modules/entity/knowledges.vue